import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WGGameConfig} from "../../../WGGameConfig";
import {WGEngineManager} from "../../../engine/WGEngineManager";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {Power2, TimelineMax, TweenLite} from "gsap";

export class StickyWildView extends BaseView {

    public _lockingWildAnimationOnReels: TimelineSprite[] = [];
    public _lockingCageContainer: PIXI.Sprite[] = [];
    public _lockedReels: boolean[] = [false, false, false, false, false, false];
    public _stickWildShine: PIXI.Sprite;
    private _layer: ScalableLayer;

    /**
     * cage, and chain animation to be created from here
     */
    protected initAnimations(): void {
        this._layer = StageManager.getLayer(WGGameConfig.instance.LAYERS.CHAIN_ANIMATION.name);
        for (let i: number = 0; i < 4; i++) {
            let lockingCage: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures("wild_reel_lock_Cage")[0]);
            let lockingAnimation: TimelineSprite = new TimelineSprite(GameResources.getTextures("wild_reel_loock_Animation"), 30);
            lockingAnimation.anchor.set(0.5);
            lockingCage.anchor.set(0.5);
            this._layer.addChild(lockingCage, lockingAnimation);
            lockingAnimation.position.set(((i + 1) * 120) + 53, 420);
            lockingCage.position.set(((i + 1) * 120) + 63, 390);
            lockingAnimation.visible = false;
            lockingCage.visible = false;
            lockingCage.mask = WGEngineManager.getReel(i + 1).mask;
            this._lockingWildAnimationOnReels.push(lockingAnimation);
            this._lockingCageContainer.push(lockingCage);
        }

        this._stickWildShine = this._layer.addChild(new PIXI.Sprite(GameResources.getTextures("wild_shine")[0]));
        this._stickWildShine.anchor.set(0.5);
        this._stickWildShine.scale.set(1.95);
        this._stickWildShine.blendMode = PIXI.BLEND_MODES.ADD;
        this._stickWildShine.alpha = 0;
        this._stickWildShine.position.set(((2) * 120) + 60, 380);

    }

    /**
     * function to hide all sticky wild lock,cage animation
     */
    public hideAlllockingReelAnimation(): void {
        this._lockingWildAnimationOnReels.forEach((value: TimelineSprite, index: number) => {
            if (value.visible) {
                TweenLite.to(value, 0.2, {alpha: 0});
                TweenLite.to(this._lockingCageContainer[index], 0.2, {alpha: 0}).eventCallback("onComplete", () => {
                    value.visible = false;
                    this._lockingCageContainer[index].visible = false;
                    value.alpha = 1;
                    this._lockingCageContainer[index].alpha = 1;
                });
            }
        });
    }

    public playShineAnimOnWIld(reelId: number): TimelineMax {
        let tl: TimelineMax = new TimelineMax();
        tl.add(() => {
            this._stickWildShine.position.set(((reelId) * 120) + 60, 380);
        });
        tl.add(TweenLite.fromTo(this._stickWildShine, 0.2, {alpha: 0}, {
            ease: Power2.easeIn
            , alpha: 1
        }));
        tl.add(TweenLite.fromTo(this._stickWildShine, 0.2, {alpha: 1}, {
            ease: Power2.easeOut,
            alpha: 0
        }));
        return tl;
    }
}